import React from 'react';
import hoverManager from '../../../../utils/HoverManager';
import storeManager from '../../../../../store/StoreManager';
import mouseUtils from '../../../../utils/MouseUtils';
import { expandFontLineHeight } from '../../../../../actions/MenuActions';

export const ShapeTypeElement = React.createClass({
    getInitialState() {
        return {
            isOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });

        if (this.props.index === 5)
            hoverManager.show(this.refs.button, this.getAriaLabel(), 'left', true);
        else
            hoverManager.show(this.refs.button, this.getAriaLabel(), 'bottom', true);
    },
    onMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.executeCommand(this.props.contextTarget.uuid, this.props.type);
        this.updateButtonFocus();
    },
    updateButtonFocus() {
        setTimeout(function() {
            this.refs.button.focus();
        }.bind(this), 100);
    },
    getContextTarget() {
        let shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.contextTarget.uuid)
                return shapes[i];
        }

        return this.props.contextTarget;
    },
    getAriaLabel() {
        switch(this.props.index) {
            case 0: {
                return hoverManager.getText('textBox');
            }
            case 1: {
                return hoverManager.getText('textBoxSimple');
            }
            case 2: {
                return hoverManager.getText('speechBubble');
            }
            case 3: {
                return hoverManager.getText('thoughtBubble');
            }
            case 4: {
                return hoverManager.getText('screamBubble');
            }
            case 5: {
                return hoverManager.getText('complexSpeechBubble');
            }
        }
    },
    onFocusHandler() {
        if (document.activeElement.id.indexOf('textBoxSimpleButton') != -1)
            storeManager.getStore().dispatch(expandFontLineHeight(false));
    },
    render() {
        let gap = 2;
        let width = this.props.width - gap;
        let contextTarget = this.getContextTarget();
        let elementStyle = {
            position: 'absolute',
            top: 0,
            left: this.props.index * (width + gap),
            width: width,
            height: width,
            backgroundColor: 'white',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            lineHeight: 1.72222,
            borderStyle: 'none',
            cursor: 'pointer'
        };

        if (this.state.isOver) {
            elementStyle.backgroundColor = '#edefff';
            elementStyle.borderRadius = 5;
            elementStyle.borderWidth = 1;
            elementStyle.borderStyle = 'solid';
            elementStyle.borderColor = '#9ea2fd';
        } else
        if (contextTarget.type === this.props.type) {
            elementStyle.backgroundColor = '#edefff';
            elementStyle.borderRadius = 5;
            elementStyle.borderWidth = 1;
            elementStyle.borderStyle = 'solid';
            elementStyle.borderColor = '#2377bb';
        }

        const iconStyle = {
            position: 'absolute',
            width: elementStyle.width - 2 *3,
            left: 3,
            top: 5
        };

        return (
            <button ref="button" id={this.props.id} aria-label={this.getAriaLabel()} style={elementStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onClick} onClick={this.onClick} onFocus={this.onFocusHandler}>
                <img alt='' aria-hidden='true' style={iconStyle} src={this.props.src}/>
            </button>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/ShapeTypeElement.js
 **/